import { CmsGroupMarketingPreferencesFieldset } from './cms-group-marketing-preferences-fieldset.interface';
import { GroupMarketingPreferencesFormValue } from './group-marketing-preferences-form-value.type';

export interface GroupMarketingPreferencesFormConfig {
  groupCodes: string[];
  cmsData?: CmsGroupMarketingPreferencesFieldset;
  initialValue?: Partial<GroupMarketingPreferencesFormValue>;
}
